import { revalidatePath } from "@/lib/revalidate";

import { ApiError, createRecord, updateRecord } from "@/lib/api/client";
import type { MasterRecordPayload } from "@/lib/api/types";

export type SaveRecordResult =
  | { ok: true; code: string }
  | { ok: false; error: string; violations: string[] };

async function save(
  sport: string,
  master: string,
  run: () => Promise<{ code: string }>,
): Promise<SaveRecordResult> {
  try {
    const record = await run();
    revalidatePath(`/${sport}/masters/${master}`);
    return { ok: true, code: record.code };
  } catch (error) {
    if (error instanceof ApiError) {
      return { ok: false, error: error.message, violations: error.violations };
    }
    return { ok: false, error: "Unexpected error saving the record.", violations: [] };
  }
}

/** Create a record. Validation failures (422) come back for inline display
 * rather than throwing — the same contract the definition builder uses. */
export async function createRecordAction(
  sport: string,
  master: string,
  payload: MasterRecordPayload,
): Promise<SaveRecordResult> {
  return save(sport, master, () => createRecord(sport, master, payload));
}

export async function updateRecordAction(
  sport: string,
  master: string,
  code: string,
  payload: MasterRecordPayload,
): Promise<SaveRecordResult> {
  return save(sport, master, () => updateRecord(sport, master, code, payload));
}
